import AdminCreate from 'components/admin/AdminCreate';
import AdminDashboard from 'components/dashboard/admin/AdminDashboard';
import AdminEdit from 'components/admin/AdminEdit';
import AdminList from 'components/admin/AdminList';
import AdminMore from 'components/admin/more/AdminMore';
import PlanRequestList from 'components/plan/PlanRequestList';
import CouponsAdminPage from 'components/admin-coupons/CouponsAdminPage';
import OrganizationsAdminPage from 'components/admin-organizations/OrganizationsAdminPage';
import OrganizationDetail from 'components/admin-organizations/OrganizationDetail';
import OrgManagersAdminPage from 'components/org-manager-admin/OrgManagersAdminPage';
import BillingSettings from 'components/admin/BillingSettings';
import NutritionAdminPage from 'components/nutrition/NutritionAdminPage';
import MotivationalPhrasesAdmin from 'components/admin/MotivationalPhrasesAdmin';
import PlayModerationPage from 'components/play/PlayModerationPage';
import PlayMusicAdminPage from 'components/play/admin/PlayMusicAdminPage';
import PlayRecoveryAdminPage from 'components/play/admin/PlayRecoveryAdminPage';
import DefaultLayout from 'components/layout/DefaultLayout';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

const adminRoutes = [
  {
    key: 'admin-dashboard',
    exact: true,
    path: routes.adminDashboard.path,
    component: AdminDashboard,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'play-moderation',
    exact: true,
    path: routes.playModeration.path,
    component: PlayModerationPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    // La entrenadora también alimenta la librería de música (gate por rol en el backend).
    key: 'play-music-admin',
    exact: true,
    path: routes.playMusicAdmin.path,
    component: PlayMusicAdminPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  },
  {
    key: 'play-recovery-admin',
    exact: true,
    path: routes.playRecoveryAdmin.path,
    component: PlayRecoveryAdminPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  },
  {
    key: 'admin-create',
    exact: true,
    path: routes.createAdmin.path,
    component: AdminCreate,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-edit',
    exact: true,
    path: routes.editAdmin.path,
    component: AdminEdit,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-list',
    exact: true,
    path: routes.listAdmin.path,
    component: AdminList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-more',
    exact: true,
    path: routes.adminMore.path,
    component: AdminMore,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'plan-requests',
    exact: true,
    path: routes.planRequests.path,
    component: PlanRequestList,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-coupons',
    exact: true,
    path: routes.adminCoupons.path,
    component: CouponsAdminPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-organizations',
    exact: true,
    path: routes.adminOrganizations.path,
    component: OrganizationsAdminPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-organization-detail',
    exact: true,
    path: routes.adminOrganizationDetail.path,
    component: OrganizationDetail,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-org-managers',
    exact: true,
    path: routes.adminOrgManagers.path,
    component: OrgManagersAdminPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-billing-info',
    exact: true,
    path: routes.billingInfo.path,
    component: BillingSettings,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  },
  {
    key: 'admin-nutrition',
    exact: true,
    path: routes.adminNutrition.path,
    component: NutritionAdminPage,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator, roles.trainer]
  },
  {
    key: 'admin-motivational-phrases',
    exact: true,
    path: routes.adminMotivationalPhrases.path,
    component: MotivationalPhrasesAdmin,
    layout: DefaultLayout,
    allowedRoles: [roles.administrator]
  }
];

export default adminRoutes;
